<template lang="pug">
modal(name='CalcModal', id="calcmodal"  transition='pop-up', :clickToClose="false",  :width="smallScreen ? '100%' : '680px'", :height=" smallScreen ? scale * 560 : 'auto'",   @before-open="beforeOpen" @before-close="beforeClose" :class="smallScreen ? 'fullscreen' : ''" :scrollable="true")
  main.container.calc(:class="checked ? 'subtract-mode' : ''")
    span.calcTitle {{ edit ? 'Edit Calculator' : 'Create Calculator' }}
    button.closedialog.btn.btn-icon(type="button", v-on:click="closeModal()") ❌ 
    .form-check
      label(class='form-check-label' v-tooltip="{content: 'Use <b>scaled</b> or <b>unscaled</b> coordinates<br>default is <b>scaled</b>', classes: ['modaltip']}") 
        el-switch.scaled(v-if="mode === 'G25' || !mode ? true: false" v-model="model.scaled" :active-value="1" :inactive-value="0"  active-text="scaled" inactive-text="unscaled" v-on:change="setChanged()"  name="scaled")
    vue-form#calc(:state="formstate" @submit.prevent="onSubmit" )
      .fields()
        validate(tag="div" :custom="{customValidator: uniqueCalcName}")
          .label(v-tooltip="{content: '<b>Calculator Name</b><br/>name must be unique within your set of calculators<br/>' , classes: [ 'modaltip' ]}")  Name
            span.subtext *
          fg-input( v-on:input="setChanged()" addon-left-icon="fas fa-bookmark"  autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.name" required="" name="name" placeholder="Calculator name" :disabled="isBegining() || calcDisabled")
          field-messages(name="name")
            div.validmsg 
              i(class="fas fa-check")
            div.infomsg(slot="required") duplicate calculator names not allowed
            div.errmsg(slot="customValidator") not unique or contains spaces
      .fields()
        validate(tag="div")
          .label(v-tooltip="{content: '<b>Description</b><br/>Helpful text to allow for users to identify targeted population<br/>' , classes: [ 'modaltip' ]}") Description
            span.subtext *
          //fg-input( v-on:input="setChanged()" addon-left-icon="fas fa-comment"  autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="model.description" required="" name="description" placeholder="Calculator description" :disabled="isBegining()")
          textarea.customdata(v-tooltip="{content: `<b>Description</b><br/>Helpful text to allow for users to identify targeted population<br/>` , classes: [ 'modaltip' ]}" v-model="model.description" autocomplete="off" autocorrect="off" autocapitalize="none" cols='30' rows='2' spellcheck="false" name="description" type="" required="" :placeholder="'Calculator description'" class="description" :disabled="isBegining()")
          field-messages(name="description")
      .fields()
        validate(tag="div") 
          .label(v-tooltip="{content: 'Create Averages/Medians for grouped samples<br/>default is \"yes\"<br/>', classes: [ 'modaltip' ]}") Create Averages
          el-switch.public( tabindex="-1" v-model="model.settings.aggregate" active-text="Yes" inactive-text="No" name="aggregate" :disabled="isBegining()" v-on:change="syncGrouped('aggregate')")
          .label(v-tooltip="{content: 'Use nMonte mode<br/>default is \"no\"<br/>Note: The calculator will run slower with this enabled', classes: [ 'modaltip' ]}") Use nMonte mode
          el-switch.public( tabindex="-1" v-model="model.settings.nmonte" v-on:change="setChanged()"  active-text="Yes" inactive-text="No" name="nmonte" :disabled="isBegining()")
      .fields.public(tabindex="-1" style="min-height:108px;") 
        validate(tag="div") 
          //collapse( :active-index="1" :v-model="collapsed")
            collapse-item.label(title="Settings" name="settings")
          .label() Settings
          .fields(style='height: 160px')
            div.switchgroup(v-if="!model.settings.nmonte" style='margin-top:-180px; margin-left: 150px;min-width: 400px; position: absolute; height: 20px')
              span.slidergroup.limit
                span.sliderlabel Limit
                vue-slider.limit(v-tooltip="`Set maximum allowable number of components in results`" v-model="model.settings.slider.limit.value"  :data="model.settings.slider.limit.data[0]" :marks="true" width="80%" v-on:change="setChanged()" )
              span.slidergroup.min
                span.sliderlabel Min Cutoff
                vue-slider.min(v-tooltip="`Set minimum value threshold<br/>Results will only include components that score higher than this value`" v-model="model.settings.slider.min.value"  :data="model.settings.slider.min.data[0]" :marks="true" width="80%" v-on:change="setChanged()")
            div.switchgroup(v-if="model.settings.nmonte" style='margin-top:-180px; margin-left: 150px;min-width: 400px; position: absolute; height: 20px')
              span.slidergroup.limit
                span.sliderlabel Batches
                vue-slider.limit(v-tooltip="`Set number of batches for nMonte`" v-model="model.settings.slider.batches.value"  :data="model.settings.slider.batches.data[0]" :marks="true" width="80%" v-on:change="setChanged()" )
              span.slidergroup.min
                span.sliderlabel Cycles
                vue-slider.min(v-tooltip="`Set number of cycles for nMonte`" v-model="model.settings.slider.cycles.value"  :data="model.settings.slider.cycles.data[0]" :marks="true" width="80%" v-on:change="setChanged()")
            div.switchgroup(style='margin-top:-20px; margin-left: 150px;min-width: 400px; position: absolute; height: 20px')
              el-switch( v-model="model.settings.penalty" active-text="DEFAULT PENALTY" inactive-text="OFF" style="margin-right: 20px; left:0;position:absolute;" v-on:change="setChanged()" name="penalty" )
              el-switch(:disabled="!model.settings.aggregate" v-model="model.settings.grouped.removeoutliers" active-text="REMOVE OUTLIERS" inactive-text="OFF" v-on:change="syncGrouped('removeoutliers')" style="left:200px;position:absolute; height: 20px" name="outliers" )
            div.switchgroup(style='margin-top:40px; margin-left: 150px;min-width: 400px; position: absolute;')
              el-switch(:disabled="!model.settings.aggregate" v-model="model.settings.grouped.average" active-text="USE AVERAGE" inactive-text="OFF" v-on:change="syncGrouped('average')"  style="margin-right: 20px;left:0;position:absolute;" name="average" )
              el-switch(:disabled="!model.settings.aggregate" v-model="model.settings.grouped.median" active-text="USE MEDIAN" inactive-text="OFF" v-on:change="syncGrouped('median')" style="left:200px;position:absolute;" name="median" )
      .fields.calcType()
        validate(tag="div")
          .label(v-tooltip="{content: '<b>Description</b><br/>Type of Calculator<br/>' , classes: [ 'modaltip' ]}") Type
          fg-input( :disabled="true" addon-left-icon="far fa-hand-pointer"  autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="mode" required="" name="type" )
      .fields.public(tabindex="-1")
        validate(tag="div") 
          .label(v-tooltip="{content: 'Allow calculator to be used publicly<br/>default is \"no\"<br/>', classes: [ 'modaltip' ]}") Public
          el-switch.public( tabindex="-1" v-on:change="setChanged()"  v-model="model.public" :active-value="1" :inactive-value="0"  active-text="Yes" inactive-text="No" name="public" :disabled="isBegining()")
          el-switch.download(v-tooltip="{content: 'Allow calculator to be downloaded as a datasheet<br/>default is \"no\"<br/>', classes: [ 'modaltip' ]}" v-if="model.public" tabindex="-1" v-on:change="setChanged()"  v-model="model.download" :active-value="1" :inactive-value="0"  active-text="Downloadable" inactive-text="No" name="public" :disabled="isBegining()")
      .fields.public(tabindex="-1")
        validate(tag="div") 
          .label(v-tooltip="{content: 'Set this switch to \"yes\" when you want to use a CSV data sheet to create a calculator instead of selecting groups from the database<br/>', classes: [ 'modaltip' ]}") Use Data Sheet
          el-switch.public( tabindex="-1"  v-model="model.external" :active-value="1" :inactive-value="0"  active-text="Yes" inactive-text="No" name="external" v-on:change="setDataSheet()" :disabled="isBegining()")
      .fields.customdata(v-if="model.external == 1")
        validate(tag="div" :custom="{customValidator: validateCSV}")
          .label(v-tooltip="{content: `<b>Calculator Sheet</b><br/>You can paste the custom data here` , classes: [ 'modaltip' ]}") 
          span.subtext 
          textarea.customdata(v-tooltip="{content: `<b>Calculator Sheet</b><br/>You can paste the custom data here` , classes: [ 'modaltip' ]}" v-model="csv" autocomplete="off" autocorrect="off" autocapitalize="none" cols='70' rows='10' spellcheck="false" name="pasted" type="" required="" :placeholder="mode === 'G25' ? placeHolderG25 : placeHolderCustom" class="custom")
          field-messages(name="pasted")
            div.csv.validmsg 
              i(class="fas fa-check")
            div.csv.infomsg(slot="required") Paste CSV data in the text box <b>without headers</b> (PC1,PC2,PC3...)<br/>Samples can be formatted as <b>Component&thinsp;:&thinsp;Group&thinsp;:&thinsp;Sample</b> or <b>Group&thinsp;:&thinsp;Sample</b> or <b>Sample</b>
            div.csv.errmsg(slot="customValidator") {{ csvValidation }}
      .base-container(v-if="model.external == 0")
        .row
      .component-container(v-if="model.external == 0")
        swiper(id="calCarousel" ref="carousel" :simulateTouch="false"  :options="options" onObserverUpdate="console.log('updated')")
          swiper-slide.slide(v-for='(component, index) in calcComponents' :key="index")
            .fields()
              validate(tag="div" :custom="{customValidator: uniqueCompName}")
                .label(v-tooltip="{content: '<b>Component Name</b><br/>name must be unique<br/>' , classes: [ 'modaltip' ]}")  Component
                  span.subtext *
                fg-input(  addon-left-icon="fas fa-user" v-on:input="setChanged()"  autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="calcComponents[index].name" required="" name="component" placeholder="Component Name")
                field-messages(name="component")
                  div.validmsg 
                    i(class="fas fa-check")
                  div.infomsg(slot="required") duplicate component names not allowed
                  div.errmsg(slot="customValidator") not unique
            .fields
              el-switch(:class="'groupSamples'" v-model="groupSamples" active-text="Individual Samples" inactive-text="Groups" v-on:change="") 
              multiselect.rightSelect.right( v-on:input="setChanged()" ref="leftSelectinput" v-model="calcComponents[index].groups ", :options="groupOptions", :multiple="true", placeholder="Select" label="label", track-by="label", :custom-label="customLabel", open-direction="bottom", :showLabels="false", :taggable="false", :max="20", :tagPosition="'bottom'" :hideSelected="true"  :optionsLimit="20" :closeOnSelect="false" :clearOnSelect="true" :maxHeight="120" :internalSearch="true"  :optionHeight="30" :preselect-first="false"   )
              .label(v-tooltip="{content: 'Source groups for component' , classes: [ 'modaltip' ]}") Groups
                span.subtext *
            .row
              .buttons 
                button.btn.btn-block.btn-icon.btn-primary(v-tooltip="{content: 'Remove this component from calculator' , classes: [ 'modaltip' ]}" :class="calcComponents.length >1 ? '' : 'btn-disabled'" type='button', v-on:click='removeComponent(index)')
                  i.fas.fa-minus
                button.btn.btn-icon.btn-info(v-tooltip="{content: 'Add additional component' , classes: [ 'modaltip' ]}" :class="appendable ? '' : 'btn-disabled'" type='button', v-on:click='addComponent')
                  i.fas.fa-plus
        .swiper-pagination(slot="pagination")
      .row
    .swiper-button-next(slot="button-next" v-if="model.external == 0")
    .swiper-button-prev(slot="button-prev" v-if="model.external == 0")
    .buttons.save(style="display:inline-block")            
      n-button(type='info' class='primary'  @click.native="closeModal()"  v-tooltip="{content: 'cancel new calculator creation' , classes: [ 'modaltip' ]}") Cancel
      n-button.primary.unchanged(v-if="!savable" type='default' style="opacity:0.3" ) Save
      n-button.primary.changed(v-if="savable" type='info' @click.native="save()"  v-tooltip="{content: 'save calculator' , classes: [ 'modaltip' ]}") 
        geno-spinner(:loading="saving" :text="'Save'" :size="32")
</template>
<script lang="js">
import getGhostQuery from "@/graphql/getGhostQuery"
import createCalcMutation from "@/graphql/createCalcMutation";
import createCalcSheetMutation from "@/graphql/createCalcSheetMutation";
import {
    mapState
} from 'vuex'
import {
    Card,
    Button,
    FormGroupInput,
    Checkbox,
    Pagination
} from '@/components'
import {
Collapse,
CollapseItem
} from 'element-ui'
import {
    Switch
} from 'element-ui'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
export default {
    data() {
        return {
            name: 'CalcModal',
            groupSamples: false,
            csv: '',
            collapsed: true,
            csvValidation: '',
            changed: false,
            calcDisabled: false,
            formDisabled: false,
            filteredNames: [' ', '|', ':' , '@', '~','+','{', '}', '(', ')', '!','[',']','%','#', '*', '^', '`', ',', "'", '"', '.', '=', '>', '<', '?', ';', '/', '\\', '&'],
            edit: false,
            index: -1,
            formstate: {},
            scaled: 1,
            checked: false,
            smallScreen: window.innerWidth < 620 ? true : false,
            scale: !this.smallScreen ? 1 : window.innerWidth / 620  < 0.8 ?  window.innerWidth / 620 + 0.1 : 0.9,
          settings : { grouped: { median: false, average: false, removeoutliers: false }, penalty: true, aggregate: true,
            slider: {
                limit: {
                    value: 'OFF',
                    data: [
                        ['OFF',3,4,5,6,7,8]
                    ]
                },
                min: {
                    value: '0%',
                    data: [
                        ['0%','1%', '2%']
                    ]
                },
                },
          },
            output: '',
            sample: '',
            placeHolderG25: 'Swedish,0.12,0.15,0.06,0.00,0.06,-0.01,-0.00,0.00,0.03,0.05,-0.00,0.01,-0.03,-0.01,0.01,0.01,0.01,0.00,-0.00,-0.00,0.01,0.00,-0.01,-0.02,-0.00\nEnglish,0.13,0.14,0.06,0.05,0.04,0.01,0.00,0.00,0.01,0.00,-0.00,0.01,-0.02,-0.01,0.02,0.00,-0.01,0.00,0.00,0.00,0.01,0.00,-0.01,0.01,0.00\nFrench,0.12,0.15,0.06,0.03,0.04,0.01,0.00,0.00,0.01,0.02,-0.01,0.00,-0.02,-0.01,0.02,-0.01,-0.02,0.00,0.00,0.01,0.00,0.00,-0.01,-0.00,-0.00\nGerman,0.13,0.13,0.08,0.07,0.04,0.02,0.01,0.01,0.01,-0.01,-0.00,0.00,-0.01,-0.01,0.02,0.01,-0.00,0.01,0.00,0.01,0.01,0.00,-0.00,0.02,0.00\nPolish,0.13,0.12,0.09,0.09,0.04,0.04,0.01,0.02,-0.00,-0.04,0.00,-0.01,0.02,0.03,-0.01,-0.00,0.00,0.00,0.00,0.00,-0.00,-0.01,0.01,-0.01,-0.00\nTurkish,0.05,0.15,-0.05,-0.11,-0.00,-0.05,-0.02,-0.00,0.05,0.01,0.01,-0.01,0.03,-0.00,0.00,-0.01,-0.01,-0.00,-0.00,0.01,0.01,0.00,-0.00,0.00,-0.00\nLebanese,0.08,0.14,-0.06,-0.09,-0.01,-0.03,-0.00,-0.01,0.01,0.01,0.01,-0.01,0.01,-0.00,-0.01,0.01,0.01,-0.00,0.00,-0.00,0.00,0.00,-0.00,0.00,-0.00\nAfrican,0.10,-0.04,0.11,0.08,-0.01,0.01,0.01,0.01,0.00,-0.03,0.03,-0.01,0.02,-0.02,-0.01,-0.00,-0.00,-0.00,-0.01,0.00,0.02,-0.00,-0.00,0.00,0.00\nGreek,0.12,0.15,0.02,-0.03,0.02,-0.01,-0.01,-0.01,0.00,0.03,0.01,0.00,-0.01,-0.00,-0.02,-0.01,0.01,-0.00,0.01,-0.01,-0.01,0.00,-0.00,-0.00,-0.00\nRussian,0.13,0.12,0.07,0.06,0.04,0.03,0.01,0.01,0.00,-0.02,-0.00,-0.01,0.02,0.03,-0.01,-0.00,0.00,-0.00,0.00,0.00,-0.00,-0.01,0.01,-0.01,-0.00\nMoroccan,-0.05,0.13,-0.01,-0.07,0.03,-0.04,-0.03,0.01,0.07,0.03,0.01,-0.01,0.02,-0.02,0.02,-0.01,0.00,-0.02,-0.05,0.01,-0.01,-0.04,0.03,-0.00,0.01\nMongolian,0.12,0.15,-0.02,-0.05,0.01,-0.02,-0.00,-0.01,0.00,0.02,0.00,0.00,-0.01,-0.01,-0.01,-0.00,0.00,0.00,0.01,-0.00,0.00,0.01,0.00,0.00,-0.00\nSpanish,0.13,0.15,0.04,-0.01,0.05,-0.01,0.00,-0.00,0.02,0.04,-0.00,0.01,-0.02,-0.01,-0.00,-0.00,0.00,0.00,0.01,-0.00,-0.00,0.00,-0.00,-0.00,-0.00\nArmenian,0.11,0.10,-0.02,-0.01,-0.03,0.00,0.00,-0.00,-0.04,-0.02,0.00,0.00,-0.02,-0.01,0.00,-0.01,0.01,-0.01,-0.00,0.01,0.00,0.00,-0.00,0.00,-0.00\nRomanian,0.10,0.05,0.02,0.05,-0.03,0.02,0.00,-0.00,-0.03,-0.03,-0.00,-0.00,-0.00,-0.02,0.02,0.00,-0.01,-0.00,-0.00,-0.00,-0.01,-0.00,0.00,0.00,-0.00\nIndian,0.13,0.15,0.03,-0.02,0.02,-0.01,-0.01,0.01,0.00,0.03,0.00,0.01,-0.02,-0.00,-0.01,-0.01,-0.01,0.00,0.01,-0.01,-0.00,0.01,0.00,0.00,0.00',
            placeHolderCustom: 'Swedish,12.00,15.00,6.00,0.00,6.00,1.00,0.00,0.00,3.00,5.00,0.00\nEnglish,13.00,14.00,6.00,5.00,4.00,1.00,0.00,0.00,1.00,0.00,0.00\nFrench,12.00,15.00,6.00,3.00,4.00,1.00,0.00,0.00,1.00,2.00,1.00\nGerman,13.00,13.00,8.00,7.00,4.00,2.00,1.00,1.00,1.00,1.00,0.00\nPolish,13.00,12.00,9.00,9.00,4.00,4.00,1.00,2.00,0.00,4.00,0.00\nTurkish,5.00,15.00,5.00,11.00,0.00,5.00,2.00,0.00,5.00,1.00,1.00\nLebanese,8.00,14.00,6.00,9.00,1.00,3.00,0.00,1.00,1.00,1.00,1.00\nAfrican,10.00,4.00,11.00,8.00,1.00,1.00,1.00,1.00,0.00,3.00,3.00\nGreek,12.00,15.00,2.00,3.00,2.00,1.00,1.00,1.00,0.00,3.00,1.00\nRussian,13.00,12.00,7.00,6.00,4.00,3.00,1.00,1.00,0.00,2.00,0.00\nMoroccan,5.00,13.00,1.00,7.00,3.00,4.00,3.00,1.00,7.00,3.00,1.00\nMongolian,12.00,15.00,2.00,5.00,1.00,2.00,0.00,1.00,0.00,2.00,0.00\nSpanish,13.00,15.00,4.00,1.00,5.00,1.00,0.00,0.00,2.00,4.00,0.00\nArmenian,11.00,10.00,2.00,1.00,3.00,0.00,0.00,0.00,4.00,2.00,0.00\nRomanian,10.00,5.00,2.00,5.00,3.00,2.00,0.00,0.00,3.00,3.00,0.00\nIndian,13.00,15.00,3.00,2.00,2.00,1.00,1.00,1.00,0.00,3.00,0.00',
            public: 0,
            saving: false,
            model: {settings:{
            grouped: { median: false, average: false, removeoutliers: false },
            penalty: true,
            aggregate: true,
            nmonte: false,
            slider: {
                limit: {
                    value: 'OFF',
                    data: [
                        ['OFF',3,4,5,6,7,8]
                    ]
                },
                min: {
                    value: '0%',
                    data: [
                        ['0%','1%', '2%']
                    ]
                },
                },
            }},
            ghostSample: [],
            groupJSON: [],
            sampleJSON: [],
            calcLength: { 'G25' : 25, 'HARAPPAWORLD': 16, 'EUROGENESK13': 13,'DODECADK12B': 12,'GLOBE13': 13, 'K36': 36 },
            generation: {
                1: 0
            },
            append: false,
            options: {
                mousewheel: false,
                simulateTouch: false,
                cssMode: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                }
            },
    typeOptions: [
          { label: 'Global 25 (G25)', value: 'G25', components: 25 },
          { label: 'HarappaWorld', value: 'HARAPPAWORLD', components: 16  },
          { label: 'Eurogenes K13', value: 'EUROGENESK13', components: 13  },
          { label: 'Dodecad World K12', value: 'DODECADK12B', components: 12  },
          { label: 'Dodecad Globe K13', value: 'GLOBE13', components: 13  },
          { label: 'Eurogenes Global K36', value: 'K36', components: 36 },
          { label: 'Custom Coordinates', value: 'CUSTOM' }
  ],
            calcComponents: [{
                index: 0,
                groups: []
            }],
        }
    },
    computed: {
        ...mapState({
            onLine: 'onLine',
            geo: 'geo',
            fadeIn: 'fadeIn',
            activePane: 'activePane',
            primaryT: 'primaryTabs',
            secondaryT: 'secondaryTabs',
            lastQuery: 'lastQuery',
            firstRun: 'g25firstRun',
            subs: 'subscription',
            loading: 'g25chartLoading',
            statusMessage: 'statusMessage',
            running: 'g25chartRunning',
            series: 'g25chartSeries',
            showGrid: 'showGrid',
            userSamples: 'userSamples',
            colors: 'g25chartColors',
            chartJSON: 'g25chartJSON',
            categories: 'g25chartCategories',
            chartKey: 'g25chartKey',
            slider: 'slider',
            testData: 'testData',
            user: 'user',
            lastSort: 'lastSort',
            mode:'monteMode',
            switches: 'switches'
        }),
        groupSelect: function() {
            return true
        },
        sampleOptions: function() {
            if ( !this.sampleJSON) { 
            return []
            } else {
                var newoptions = []
                var array = JSON.parse(JSON.stringify(this.sampleJSON))
                array.forEach(group => {
                    group.samples.forEach(sample => {
                        if (sample.public === 1 || sample.type !== 'user') {
                            sample.label = sample.group + " ► " + sample.sample
                            delete sample.coords;
                            delete sample.coords2;
                            newoptions.push(sample)
                        }
                    })
                })
                return newoptions
            }
        },
        groupOptions: function() {
            if ( !this.groupJSON) { 
            return []
            } else if (!this.groupSamples) {
                return this.groupJSON
            } else {
                var newoptions = []
                var array = JSON.parse(JSON.stringify(this.sampleJSON)).filter( x => x.group !== undefined && x.group !== 'undefined')
                array.forEach(group => {
                    group.samples.forEach(sample => {
                        if (( sample.public === 1 || sample.type !== 'user')) {
                            sample.label = sample.group + " ► " + sample.sample
                            delete sample.coords;
                            delete sample.coords2;
                            newoptions.push(sample)
                        }
                    })
                })
                return newoptions
            }
        },
    initData: function() {
    let data = JSON.parse(JSON.stringify(this.$store.getters.get('editCalcs')))
    return data;
    },
        savable: function() {
            return ( this.model.external ? this.changed && !this.formstate.$invalid : this.changed && !this.formstate.$invalid && this.calcComponents.length > 1 && this.appendable )
        },
        appendable: function() {
            return (( !this.formstate.$invalid && this.calcComponents[0].name && this.model.name && this.calcComponents[this.calcComponents.length - 1].groups && this.calcComponents[this.calcComponents.length - 1].groups.length > 0 )  || ( !this.formstate.$invalid && this.calcComponents[this.calcComponents.length - 1].name && this.calcComponents[this.calcComponents.length - 1].groups && this.calcComponents[this.calcComponents.length - 1].groups.length > 0 && this.model.name))
        },
        changes: function() {
            return this.$store.getters.get('changes')
        },
        samplesReady: function(evt) {
            if (this.baseArray && this.baseArray.length > 1) {
                return true
            } else {
                return false
            }
        },
    },
    mounted: function() {
        this.ancestors = [{
            generation: 2,
            index: 0
        }]
    },
    methods: {
          log: function(evt) { console.log(evt) },
          setChanged: function() { this.changed = true; },
          setDataSheet: function() { this.changed = true;
            this.calcComponents =  [{ index: 0, groups: [] }]
            this.csv = ''
          },
        syncGrouped: function(evt) {
        let switches = [ 'average', 'median', 'removeoutliers' ]
        if ( this.model.settings['aggregate'] ) {
        switches = switches.filter( x => x !== evt)
        if ( this.model.settings.grouped[evt]) {
        switches.map( x => {
        this.model.settings.grouped[x] = false
        })
        }
        } else {
        switches.map( x => {
        this.model.settings.grouped[x] = false
        })
        }
        this.changed = true;
        },
        saveCalc: function() {
            var w = this;
            var params = {
                id: this.user.username + ':calc:' + Date.now(),
                sub: this.user.username,
                calculator: JSON.stringify(this.calculator)
            }
            console.log('calc', this.calculator);
            let mutation = w.model.external ? createCalcSheetMutation : createCalcMutation
            let response = w.model.external ? 'createCalcSheet' : 'createCalc'
            this.$apollo.mutate({
                    mutation: mutation,
                    variables: {
                        params: params
                    }
                })
                .then(data => {
                    if (data.data && data.data[response] && data.data[response].exitcode === 0) {
            this.saving = false;
            this.$eventBus.$emit('appEvents',{
                exec: 'init',
                component: 'g25'
            })
    var changes = {...this.changes}
    this.calculator.class = 'default calc'
    this.calculator.components = JSON.stringify(this.calculator.components);
    this.calculator.user = this.user.username;
    this.calculator.calculator = this.calculator.name;
    this.calculator.label = unescape(this.calculator.name);
    delete this.calculator.name;
    let data = JSON.parse(JSON.stringify(this.$store.getters.get('editCalcs')))
    if ( this.index >=0 ) {
    changes[this.user.username + ':' + this.calculator.name ] = { action: 'update' }
    this.calculator.index = this.index
    data.splice(this.index, 1)
    data.push(this.calculator)
    data.sort( (a,b) => a.calculator > b.calculator ? 1 : -1 )
    } else {
    changes[this.user.username + ':' + this.calculator.name ] = { action: 'add' }
    data.push(this.calculator)
    data.sort( (a,b) => a.calculator > b.calculator ? 1 : -1 )
    }
    this.$store.commit('change', { changes: changes })
    this.$store.commit('change', { editCalcs: data })
                    this.$modal.hide('CalcModal')
                    } else {
                        console.log('calculator not created', data)
                        this.saving = false;
                    }
                })
                .catch(err => {
                    console.log(err)
                    this.saving = false;
                })
        },
            setTag: function(query, id) {
            console.log(query, id)
            },
        save: function() {
            console.log('saving');
            if ( !this.model.external ) {
            this.saving = true;
            let components = []
            this.calcComponents.map( comp => {
            let component = {}
            let groups = []
            component.component = encodeURIComponent(comp.name);
            comp.groups.map ( group => {
            groups.push( group.sample && group.group ? ( group.v ? group.group + '|' + group.v + ':' + group.sample :  group.group + ':' + group.sample ) : ( group.v ? group.label + '|' + group.v : group.label ))
            })
            component.groups = groups
            components.push(component)
            })
            let calculator = { scaled: this.model.scaled, public: this.model.public, name: encodeURIComponent(this.model.name + ( this.mode === 'G25' && this.model.name.toLowerCase().indexOf('scaled)') < 0 ? ` (${this.model.scaled ? 'Scaled': 'Unscaled'}) ` : '')), download: this.model.download,  description: this.model.description, components: components, type: this.mode, settings: this.model.settings }
            this.calculator = calculator;
            this.saveCalc();
            } else {
            this.saving = true;
            let calculator = { scaled: this.model.scaled, public: this.model.public, download: this.model.download, name: encodeURIComponent(this.model.name + ( this.mode === 'G25' && this.model.name.toLowerCase().indexOf('scaled)') < 0 ? ` (${this.model.scaled ? 'Scaled': 'Unscaled'}) ` : '')), description: this.model.description, external: true, type: this.mode, csv: this.csv, settings: this.model.settings }
            this.calculator = calculator;
            this.saveCalc();
            }
        },
        closeModal: function(flag) {
            var closable = flag ? flag : false
            if (this.appendable && !closable && this.changed) {
                this.show({
                    title: 'Are you sure?',
                    text: 'You have unsaved changes, these will be lost if you continue.',
                    class: 'warning'
                });
                return;
            } else {
                this.closable = true;
                this.defaultPagination = 1;
                this.$modal.hide('CalcModal')
            }
        },
        isBegining: function() {
            if (this.$refs.carousel) {
                return this.$refs.carousel.swiper.isBeginning === true ? false : true
            } else {
                return false
            }
        },
        showGen: function(index) {

            let gen = this.ancestors[index].generation && this.generations[this.ancestors[index].generation] ? this.generations[this.ancestors[index].generation] : this.ancestors[index].generation > 3 ? `${1 * (this.ancestors[index].generation) - 2}X Great Grand Parent` : "";
            return gen
        },
        showResults: function(evt) {
            console.log(this.ancestors[evt])
        },
        show: function(params) {
            var w = this;
            var title = params.title ? params.title : 'Alert!'
            var text = params.text ? params.text : 'Message received...'
            var buttons = [{
                    title: 'Continue',
                    default: false, // Will be triggered by default if 'Enter' pressed.
                    handler: () => {
                        w.closable = true;
                        w.$modal.hide('dialog');
                        w.closeModal(true);
                    }
                },
                {
                    title: 'Cancel',
                    default: true,
                    handler: () => {
                        w.closable = false;
                        w.$modal.hide('dialog');
                    } // Button click handler
                }
            ]
            this.$modal.show('dialog', {
                title: title,
                text: text,
                class: params.class ? params.class : undefined,
                buttons: buttons
            })
        },
        beforeClose: function() {
          this.$store.commit('change', { activeModal: 'CalcSamplesModal' })
          },
        beforeOpen: function(evt) {
          this.$store.commit('change', { activeModal: 'calcmodal' })
          this.changed = false;
          this.csv = '';
          this.groupSamples = false;
          this.$gtag.event('editCalc', {
                'event_category': 'function',
                'event_label': 'User initiated'
        })
        this.saving = false;
        this.groupJSON = evt.params.groupJSON
        this.sampleJSON = evt.params.sampleJSON
        this.csv = evt.params.dataCSV ? evt.params.dataCSV  : undefined
          if ( evt.params.action === 'info' || evt.params.action === 'edit' ) {
          this.formDisabled = false;
          this.calcDisabled = true;
          this.index = evt.params.index
          this.edit = true
          let model = this.initData[evt.params.index]
          model.settings = model.settings && typeof(model.settings) === 'string' ? JSON.parse(model.settings) : model.settings ?  model.settings : { grouped: { median: false, average: false, removeoutliers: false }, penalty: true, aggregate: true, nmonte: false }
          model.settings.nmonte = model.settings.nmonte ? model.settings.nmonte : false
          model.settings.slider = model.settings.slider ? model.settings.slider : {}
          model.settings.slider.batches = model.settings.slider.batches ? model.settings.slider.batches :{
            value: 200,
            data: [
                [100, 200, 400, 500, 600],
                [100, 200, 300, 400, 500]
            ]
        }
          model.settings.slider.cycles = model.settings.slider.cycles ? model.settings.slider.cycles : {
            value: 200,
            data: [
                [100, 200, 400, 500, 600],
                [100, 200, 300, 400, 500]
            ]
        }
          let initmodel = {
          name: model.calculator ? unescape(model.calculator) : '',
          description: model.description ? model.description : '',
          public: model.public ? model.public : 0,
          download: model.download ? model.download : 0,
          scaled: model.scaled ? model.scaled : 0,
          external: model.external == true ? 1 : 0,
          settings: model.settings
          }
          initmodel.settings = {...this.settings, ...initmodel.settings};
          this.model = initmodel
          let calcComponents = []
          model.components = typeof(model.components) === 'string' ? JSON.parse(model.components) : model.components;
          model.components =  model.components || []
          model.components.map( (comp, i) => {
          calcComponents[i] = { name: unescape(comp.component) }
          let groups = []
          comp.groups.map( x => {
          if ( x.split(':').length > 1 ) {
          let group = this.sampleOptions.find( g => g.group ===  x.split(':')[0].split('|')[0] && g.sample === x.split(':')[1] )
          if ( group ) groups.push(group)
          } else {
          let group = this.groupOptions.find( g => g.label === x.split('|')[0] )
          if ( group ) groups.push(group)
          }
          })
          calcComponents[i].groups = groups
          })
          this.calcComponents = calcComponents;
          } else {
          this.calcDisabled = false;
          this.edit = false;
          this.index = -1;
          this.model = {
          name: '',
          description: '',
          public: 0,
          scaled: 1,
          //settings : this.settings
          settings : { grouped: { median: false, average: false, removeoutliers: false }, penalty: true, aggregate: true, nmonte: false,
            slider: {
                limit: {
                    value: 'OFF',
                    data: [
                        ['OFF',3,4,5,6,7,8]
                    ]
                },
                min: {
                    value: '0%',
                    data: [
                        ['0%','1%', '2%']
                    ]
                },
        batches: {
            value: 200,
            data: [
                [100, 200, 400, 500, 600],
                [100, 200, 300, 400, 500]
            ]
        },
        cycles: {
            value: 200,
            data: [
                [100, 200, 400, 500, 600],
                [100, 200, 300, 400, 500]
            ]
        },
                },
          }
          }
          this.calcComponents =  [{
                index: 0,
                groups: []
            }]
          }
        },
        addComponent: function() {
            let index = this.calcComponents.length;
            this.calcComponents.push({
                index: index,
                generation: 2
            })
            this.options.initialSlide = index;
            this.$refs.carousel.swiper.update()
            setTimeout(() => {
                this.$refs.carousel.swiper.slideTo(index);
            }, 0)
        },
        removeComponent: function(index) {
            this.$refs.carousel.swiper.slidePrev(300, function() {})
            this.calcComponents.splice(index, 1)
            this.$refs.carousel.swiper.update()
        },

  uniqueSampleName: function (value) {
  return true
    if ( value.length < 2 ) return false
    if ( this.sampleDisabled ) return true;
    let check = function(str) { return value.indexOf(str) >=0 }
    if ( this.upload ) {
    var index = this.initData.findIndex( sample => sample.sample === value + '-raw' )
    } else {
    var index = this.initData.findIndex( sample => sample.sample === value )
    }
    if ( this.filteredNames.some(check) || value.substr(-4).toLowerCase() === '-sim' || value.substr(-4).toLowerCase() === '-raw' || (index >= 0 && !this.formDisabled && !this.sampleDisabled)) {
    return false
      } else {
    return true
    								}
  },
        validateCSV: function() {
        if ( this.csv && this.csv.length > 0 ) {
        try {
        let csv = this.csv.split('\n').filter(x=> x != '')
        let returnval = true
				let numeric = true
        let unique = true
        let dupes = false
        let uniquesArr = []
        let dupesArr = []
        let samplelength = true
        let existing = 0
        if ( !this.isAdmin && csv.length > 2000 ) {
        this.csvValidation = 'Too many samples in sheet. Maximum is 2000 samples per sheet'
        return false
        }
        let length = this.calcLength[this.mode] || 25
        csv.map( x => { if ( x.split(',').length !== length + 1 ) returnval = false; x.split(',').map( (y,n) => { if ( n > 0 && isNaN(parseFloat(y))) numeric = false}) })
        if ( returnval && numeric ) {
        let message
        let names = csv.map( x => x.split(',')[0]) 
        names.map( x => {
        if ( x.length < 2 ) {
        samplelength = false
        }
        })
        if ( !samplelength ) {
        this.csvValidation = 'Sample names need to be at least 2 characters long';
        return false
        }
        if ( names.length !== [...new Set(names)].length ) {
				message = `Sheet contains ${names.length - [...new Set(names)].length} duplicated sample names`
        dupes = true
        }
        let dupecount = 0;
        [...new Set(names)].map( (x,i) => {
        if ( names.filter(y => y == x).length > 1 ) {
        dupesArr.push(`${x} (${names.filter(y => y == x).length})`)
        dupecount++
        }
        })
        if ( !unique || dupes ) {
        message = !unique && dupes ? `${names.length - [...new Set(names)].length} duplicated name(s) in sheet and ${existing} existing or invalid sample name(s)` : dupes ? `Sheet contains duplicated sample name(s) - ${JSON.stringify(dupesArr).replace(/\"/g,'').replace(/\[/g,'').replace(/\]/g,'')}` : !unique && !dupes ? `Sheet contains ${existing} existing or invalid sample name(s) ${JSON.stringify(uniquesArr).replace(/"/g,'')}` :  `Sheet contains ${existing} existing sample name(s)`
        this.csvValidation = message
        return false
        }
        this.csvValidation = 'Valid CSV data'
        this.changed = true
        return true
        } else {
				let message = false
				if ( !returnval ) message = `Some rows do not contain ${length} values`
				if ( !numeric ) message = message ? message + ' & ' + 'some values are not numeric' : 'Some values in provided data are not numeric'
				this.csvValidation = message
        return false
        }
        }
        catch(err){
        console.log(err)
        this.csvValidation = 'Error validating CSV data'
        return false
        }
        } else {
        return
        }
        },
        validateCSV2: function(value) {
        try {
        let csv = this.csv.split('\n').filter(x=> x != '')
        if ( csv.length > 1500 ) {
        this.csvValidation = 'Too many samples in sheet. Maximum is 1500 samples per sheet'
        return false
        }
        let returnval = true
				let numeric = true
        let length = this.calcLength[this.mode] || 25
        csv.map( (x,i) => { if ( x.split(',').length !== length + 1 ) returnval = false; x.split(',').map( (y,n) => { if ( n > 0 && isNaN(parseFloat(y))) { console.log(`Row: ${x.split(',')[0]} (${i}) is not numeric - ${y}`); numeric = false}}) })
        if ( returnval && numeric ) {
        this.csvValidation = 'Valid CSV data'
        return true
        } else {
				let message = false
				if ( !returnval ) message = `Some rows do not contain ${length} values`
				if ( !numeric ) message = message ? message + ' & ' + 'some values are not numeric' : 'Some values in provided data are not numeric'
				this.csvValidation = message
        return false
        }
        }
        catch(err){
        console.log(err)
        this.csvValidation = 'Error validating CSV data'
        return false
        }
        },
        uniqueCalcName: function(value) {
            var index = this.initData.findIndex(sample => unescape(sample.calculator) === value)
            if (index >= 0 && !this.formDisabled && !this.calcDisabled) {
                return false
            } else {
                return true
            }
        },
        uniqueCompName: function(value) {
            let count = this.calcComponents.filter(comp => comp.name === value)
            if (value.indexOf(':') >= 0 || (count.length > 1 )) {
                return false
            } else {
                return true
            }
        },
        customLabel({
            label,
            age,
            origin,
            v,
            outlier

        }) {
            if ((age !== null && typeof(age) !== 'undefined') || (origin !== null && typeof(origin) !== 'undefined')) {
                age = age === null || typeof(age) === 'undefined' ? '' : (age - 100000) < 0 ? -1 * (age - 100000) + ' BCE' : age - 100000 + ' CE';
                origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                return (label.replace(/_/g, " ") + ' ( ' + age + ' ' + origin + ' )' + outlier).replace(/:/, ' ► ')
            } else {
                origin = origin === null | typeof(origin) === 'undefined' ? '' : origin
                outlier = typeof(outlier) !== 'undefined' && outlier === true ? ' ► Outlier ' : '';
                return (label.replace(/_/g, " ") + outlier + origin).replace(/:/, ' ► ')
            }
        },
    },
    components: {
        [Button.name]: Button,
        [Card.name]: Card,
        [Switch.name]: Switch,
        [Checkbox.name]: Checkbox,
        Collapse,
        CollapseItem,
        [FormGroupInput.name]: FormGroupInput,
        VueSlider: VueSlider
    },
}
</script>
<style lang="css">
#app #g25 #calcmodal .multiselect__tags .multiselect__placeholder {
display: none;
}
body.app-page #app #page #calcmodal .multiselect__tags .multiselect__input {
width: 100% !important;
position: relative !important;
padding: 0px;
}
body.app-page #app #page #calcmodal .multiselect__content-wrapper {
}
.results.alert {
    color: brown;
}
.switch-container {
height: 40px;
padding: 10px 10px 10px;
}

#calcsamplesmodal .component-container .swiper-slide .el-switch.groupSamples {
    position: absolute;
            left: 150px;
                bottom: 95px;
    }
#calcsamplesmodal .el-switch__label {
text-transform: uppercase;
}

.base-container {
    padding-left: 30px;
}

#calcmodal .fa,
#calcmodal .far,
#calcmodal .fas {
    opacity: 0.9;
    font-size: 14px;
}

#calcmodal .swiper-pagination {
z-index: auto;
}

#app #calcmodal #calc .buttons {
    padding: 30px 10px 30px;
}

#app #calcmodal .buttons {
    width: 100%;
    text-align: center;
}
#app #calcmodal .save.buttons {
	position: relative;
	bottom: 15px;
  margin-top: 15px;
	left: 0;
}
#app #calcmodal .slide .row {
margin-left: -7px;
}

#calcmodal .infomsg,
#calcmodal .validmsg,
#calcmodal .errmsg {
    cursor: default;
    font-size: 0.9em;
    text-align: left;
    padding-left: 20px;
    color: #a2a2a2;
    max-width: 70%;
    margin-left: 150px;
    margin-top: -5px;
    margin-bottom: 5px;
}
#calcmodal .slide .infomsg, #calcmodal .slide .validmsg, #calcmodal .slide .errmsg {
    margin-left: 125px;
}

#calcmodal .el-switch.public {
    margin-left: 150px;
    margin-top: -46px;
}
#calcmodal .el-switch.scaled {
    margin-left: -12px;
    margin-top: -6px;
}

#calcmodal .fields.public {
margin-bottom: -15px;
margin-top: -5px;
}
#calcmodal .multiselect.right {
width: 100%;
max-width: 70%;
}
#calcmodal .multiselect.right .caret {
width: 100%;
height: 100%;
position: absolute;
cursor: pointer;
}

#calcmodal.input-group, #calcmodal .form-group {
    margin-bottom: 10px;
    position: relative;
    margin-left: 150px;
    max-width: 325px;
    margin-top: -30px;
}
#calcmodal .slide .form-group.input-group {
    margin-left: 125px;
}

#app #calcmodal #calc .buttons button {
    display: inline-block;
    width: 20px;
    height: 30px;
    margin-right: 0px;
}

#app #calcmodal .buttons button.btn-disabled {
    background-color: gray !important;
    pointer-events: none;
}
#app #calcmodal .btn-block+.btn-block {
}

#app #calcmodal .ancestry-container .swiper-pagination {
    position: relative;
    text-align: center;
    margin-left: 5px;
    margin-top: -26px;
    font-weight: 700;
    z-index: 0;
}

#calcmodal .slide {
    width: 520px;
    padding: 10px 30px;
}

#app .app-page #calcmodal .swiper-button-next:focus {
    outline: none;
}

#app .app-page #calcmodal .swiper-button-prev:focus {
    outline: none;
}

#app .app-page #calcmodal .swiper-button-next {
    right: 20px;
    height: 12px;
}

#app .app-page #calcmodal .swiper-button-prev {
    left: 20px;
    height: 12px;
}


body.app-page #app #page #calcmodal .multiselect__tags {
    box-shadow: none;
}

#calcmodal .v--modal button.closedialog {
    background: transparent;
    position: absolute;
    top: -10px;
    right: 0px;
    display: inline;
    float: right;
    z-index: 9;
    box-shadow: none;
}

#app #calcmodal .v--modal button.closedialog:hover {
    box-shadow: none;
}

#app #calcmodal .v--modal button.closedialog:active {
    background: #9797971c;
}

.container.calc {
    padding: 0 50px;
    margin-top: 75px;
}

span.calcTitle {
    position: absolute;
    left: 0;
    width: 100%;
    text-align: center;
    z-index: 1;
    font-weight: 700;
    font-size: 20px;
    color: #0f5579;
    margin-top: -60px;
}

#calcmodal .right {
    order: 2;
    display: inline-block;
    max-width: 60%;
}

#calcmodal .fields {
    display: flex;
    align-items: center;
    min-height: 60px;
}
#calcmodal .component-container .fields {
    min-height: 50px;
}

#calcmodal div.label {
    order: 1;
    width: 120px;
    text-align: right;
    padding-right: 0px;
    font-weight: 700;
    font-size: 0.95em;
    cursor: default;
}

#calcmodal .swiper-container div.label,
#calcmodal .base-container div.label {
    padding-right: 30px;
}
#calcmodal .swiper-container {
padding-top: 5px;
}

#calcmodal div.suffix {
    order: 3;
    padding-left: 20px;
    font-weight: 700;
    color: brown;
}

#calcmodal div.results {
    text-align: center;
    font-weight: 700;
    color: #0f5579;
    padding: 10px 30px 25px 30px;
}

#calcmodal .slide .number-input--small.number-input--inline>input {
    width: 6.5rem;
}

#app .app-page #calcmodal .multiselect__content-wrapper {
    width: 87%;
    left: 3%;
    overflow-x: hidden;
}
#calcmodal .swiper-button-next.swiper-button-disabled, #calcmodal .swiper-button-prev.swiper-button-disabled {
    opacity: 0.10;
}
#calcmodal .number-input__button {
	    cursor: pointer;
	}
#calcmodal .number-input__button:disabled {
	    cursor: default;
	}
#calcmodal.fullscreen .v--modal {
border-radius: 0px;
}

#calcmodal.fullscreen .container.calc {
    padding: 0 10px;
    margin-top: 70px;
}
#calcmodal.fullscreen div.label {
width: 120px;
padding-right: 15px;
}
#calcmodal.fullscreen .base-container div.label, #calcmodal.fullscreen .ancestry-container div.label {
width: 100px;
}
#calcmodal.fullscreen .slide {
    padding: 10px 15px;
}
#calcmodal.fullscreen div.suffix {
max-width: 80px;
}
#calcmodal.fullscreen .input-group, #calcmodal.fullscreen  .form-group {
    margin-left: 120px;
    max-width: 55%;
}
#calcmodal.fullscreen .infomsg, #calcmodal.fullscreen .validmsg, #calcmodal.fulscreen .errmsg {
    padding-left: 20px;
    max-width: 60%;
    margin-left: 120px;
}
#calcmodal.fullscreen .base-container {
    padding-left: 15px;
}

#calcmodal .subtract-mode .generation, #calcmodal .subtract-mode .row .buttons, #calcmodal .subtract-mode .swiper-pagination {
opacity: 0.3;
pointer-events: none;
}
#calcmodal main.container .form-check {
left: -12px;
top: 10px;
z-index: 1;
}
#calcmodal main.container .form-check .form-check-label {
color: gray;
padding-left: 0;
}
#calcmodal .swiper-container {
z-index: 1;
}
#calcmodal .swiper-wrapper {
z-index: 1;
}

#calcmodal .label .subtext {
position: absolute;
        color: brown;
        margin-left: 5px;
         font-weight: 400;
}





#calcmodal .calcType .form-control:disabled, .form-control[readonly] {
    background-color: #fefefe !important;
        opacity: 1;
}

#calcmodal textarea {
padding:5px 10px;
}
#calcmodal textarea::placeholder {
opacity: 0.5;
color: slategray;
padding:5px 10px;
}
#calcmodal .csv.errmsg, #calcmodal .csv.validmsg, #calcmodal .csv.infomsg {
    max-width: 100%;
    margin-left: -10px; 
    margin-top: 5px;
    text-align: center;
}
#calcmodal .csv.errmsg {
font-weight: 700;
    color: brown;
}
#calcmodal .vue-slider {
display: inline-block;
position: absolute;
left: 20px;
top: 20px;
}
#calcmodal .slidergroup {
position: absolute;
left: 0;
width: 50%;
text-align: center;
color: gray;
text-transform: uppercase;
font-weight: 400;
font-size: 0.9em;

}
#calcmodal .slidergroup.min {
left: 50%;
padding-left: 32px;
}
#calcmodal .vue-slider.min {
left: 32px;
}
#calcmodal .slidergroup .sliderlabel {
position: relative;
}
#calcsamplesmodal .fields.customdata > div {
width: 100%;
padding-right: 5px;
}
#calcsamplesmodal textarea.customdata {
border-radius: 5px;
    border-color: #3987bf3d;
    outline: #3987bf;
    width: 100%;
}
#calcsamplesmodal textarea.customdata.description {
margin-left: 150px;
    margin-top: -20px;
    }
#calcsamplesmodal .el-switch.download {
margin-top: -45px;
margin-left: 50px;
}
body.isMobile #calcsamplesmodal .el-switch.download {
margin-left: 8px;
}
#calcsamplesmodal textarea::-webkit-scrollbar { width: 0 !important }
#calcsamplesmodal textarea  { overflow: -moz-scrollbars-none; }
body #app #g25.nmonte #calcsamplesmodal .component-container .multiselect.rightSelect.right {
z-index: 9999999;
}
body.app-page #app #calcmodala .v--modal-box.v--modal {
zoom: 90%;
margin-top: 2%;
margin-left: 5%;

}
</style>
